import {
  Box,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
  IconButton,
  Popover,
} from "@mui/material";
import { useEffect, useState } from "react";
import DotsIcon from "../IconComp/dotsIcon";
// import PdfDownloadIcon from "../../assets/icons/pdfDownloadIcon";
// import DailyExpenseReport from "./dailyExpanseReport";
import FilterIcon from "../../assets/icon/filter.svg";
import ExpenseFilterModal from "./expenseFilterModal";
import AppSnackbar from "../common/AppSnackbar";
import AddExpenseModal from "./addExpenseModal";
import AppButton from "../common/AppButton";
import PdfDownloadIcon from "../IconComp/pdfDownloadIcon";
import AppModal from "../common/AppModal";
import DailyExpenseReport from "./dailyExpanseReport";
import usePermissions from "../../hooks/usePermissions";

interface Iprops {
  isLoading?: boolean;
  clinicId?: any;
  setFormState: any;
  formState: any;
  handleOpenModal?: () => void;
  setCategoryInput?: any;
  setNameInput?: any;
  setReloadExpenses?: any;
  setFilteredExpData?: any;
  expenseData: any;
  nameInput: any;
  categoryInput: any;
  handleFilterSearch: any;
  setAnchorEl: any;
  anchorEl: any;
  fetchFilteredData: (event: any) => void;
}

const ExpenseToolBar = ({
  setReloadExpenses,
  formState,
  setFormState,
  handleFilterSearch,
  setFilteredExpData,
  setCategoryInput,
  nameInput,
  categoryInput,
  setNameInput,
  setAnchorEl,
  anchorEl,
  expenseData,
  fetchFilteredData,
}: Iprops) => {
  const [openModal, setOpenModal] = useState(false);
  const [filterData, setFilterData] = useState([]);
  const [openPdf, setOpenPdf] = useState(false);
  const isPermissions = usePermissions();
  const Account_Type = parseInt(localStorage.getItem("pharmacy_account_type") || "0", 10);
  
  const [openAddSnackbar, setOpenAddSnackbar] = useState(false);
  const handleAddSuccess = () => {
    setOpenAddSnackbar(true);
  };

  const formatForInput = (date: string) => {
    if (!date) return "";
    const d = new Date(date);
    return d.toISOString().split("T")[0]; // yyyy-mm-dd
  };

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setNameInput("");
    setCategoryInput("");
    setFilteredExpData(expenseData);
  };

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  useEffect(() => {
    fetchFilteredData(filterData);
  }, [filterData]);

  const handleOpenPdf = () => {
    setOpenPdf(true);
  };
  const handleClosePdf = () => {
    setOpenPdf(false);
  };

  return (
    <>

    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 2,
        flexWrap: "wrap",
      }}
    >
       <RadioGroup

          row={false}
          sx={{
            flexDirection: "row",
          }}
          aria-label="date-filter-type"
          name="date-filter-type"
          value={formState.dateFilterType}
          onChange={(e) =>
            setFormState((prevFormState: any) => ({
              ...prevFormState,
              dateFilterType: e.target.value,
            }))
          }
        >
          <FormControlLabel value="single" control={<Radio />} label="Date" />
          <FormControlLabel
            value="range"
            control={<Radio />}
            label="Date Range"
          />
        </RadioGroup>

        <Box
          sx={{
            display: "flex",
            px: 2,
            cursor: expenseData?.length === 0 ? "not-allowed" : "pointer",
            alignItems: "center",
            opacity: expenseData?.length === 0 ? 0.5 : 1,
          }}
          onClick={expenseData?.length === 0 ? undefined : handleOpenPdf}
        >
          <Box sx={{ mr: 1 }}>Download Expense PDF</Box>
          <PdfDownloadIcon />
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: {
            xs: "column",
            sm: "row",
          },
          alignItems: {
            xs: "flex-start", // Align items to the start when in a column (smaller screens)
            sm: "center", // Center items when in a row (larger screens)
          },
          justifyContent: "space-between",
          flexWrap: "wrap",
          mt: 2,
          gap: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          {formState.dateFilterType === "single" && (
            <TextField
              type="date"
              value={formatForInput(formState.selectedDate)}
              onChange={(e) =>
                setFormState((prev: any) => ({
                  ...prev,
                  selectedDate: e.target.value,
                }))
              }
              InputLabelProps={{ shrink: true }}
              sx={{
                height: "36px",
                width: "227px",
                "& .MuiOutlinedInput-root": { height: "36px" },
                "& .MuiInputBase-input": { height: "36px", padding: "0 8px" },
              }}
            />
          )}

          {formState.dateFilterType === "range" && (
            <Box
              sx={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}
            >
              <TextField
                type="date"
                value={formState.fromDate}
                onChange={(e) =>
                  setFormState((prevFormState: any) => ({
                    ...prevFormState,
                    fromDate: e.target.value,
                  }))
                }
                InputLabelProps={{ shrink: true }}
                sx={{
                  height: "36px",
                  width: "227px",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "4px 0 0 4px",
                    height: "36px",
                  },
                  "& .MuiInputBase-input": {
                    height: "36px",
                    padding: "0 8px",
                  },
                }}
              />
              <DotsIcon />
              <TextField
                type="date"
                value={formState.toDate}
                onChange={(e) =>
                  setFormState((prevFormState: any) => ({
                    ...prevFormState,
                    toDate: e.target.value,
                  }))
                }
                InputLabelProps={{ shrink: true }}
                sx={{
                  height: "36px",
                  width: "227px",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "0 4px 4px 0",
                    height: "36px",
                  },
                  "& .MuiInputBase-input": {
                    height: "36px",
                    padding: "0 8px",
                  },
                }}
              />
            </Box>
          )}
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            mt: { xs: 2, sm: 0 },
          }}
        >
          {(Account_Type === 0 || (isPermissions?.add && Account_Type === 1)) && (
            <AppButton
            title="Add Expense"
            onClick={handleOpenModal}
            padding="5px 10px 5px 10px"
            type="button"
          />

          )}
          
          <Box sx={{ marginTop: 0 }}>
            <IconButton onClick={handleClick} style={{ cursor: "pointer" }}>
              <img src={FilterIcon} alt="Filter Icon" />
            </IconButton>
            <Popover
              id={id}
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "center",
              }}
              sx={{
                ".MuiPopover-paper": {
                  width: "auto",
                  maxWidth: "90%",
                  position: "absolute",
                },
              }}
            >
              <Box>
                <ExpenseFilterModal
                  anchorEl={anchorEl}
                  handleClose={handleClose}
                  handleFilterSearch={handleFilterSearch}
                  nameInput={nameInput}
                  categoryInput={categoryInput}
                  setNameInput={setNameInput}
                  handleCategorySearch={(data) => {
                    setCategoryInput(data);
                  }}
                />
              </Box>
            </Popover>
          </Box>
        </Box>
      </Box>

      <AppSnackbar
        message="Added Successfully!"
        open={openAddSnackbar}
        handleClose={() => setOpenAddSnackbar(false)}
      />
      {/* Add Expense Modal */}
      {openModal && (
        <AddExpenseModal
          handleClose={handleCloseModal}
          setReloadExpenses={setReloadExpenses}
          onAddSuccess={handleAddSuccess}
        />
      )}
      <AppModal
        title={"Daily Expense Report"}
        open={openPdf}
        handleClose={handleClosePdf}
        fullScreen={false}
        maxWidth="md"
      >
        <DailyExpenseReport
          handleClosePdf={handleClosePdf}
          expenseData={expenseData}
          formState={formState}
        />
      </AppModal>
    </>
  );
};

export default ExpenseToolBar;
